import { Injectable } from '@angular/core';
import { SpaceEntry } from '@osos/shared/api';
import {
  SPACE_CORE_ENTITY_ID,
  SpaceEntryPresenterModel,
} from '@osos/shared/types';
import { ParserBase } from '../../bases/parser/parser-base';

@Injectable({
  providedIn: 'root',
})
export class SpaceEntryParserV1Service extends ParserBase<
  SpaceEntry,
  SpaceEntryPresenterModel
> {
  constructor() {
    super(SpaceEntry, SpaceEntryPresenterModel, 1);
  }
  getPresenterModel(model: Partial<SpaceEntry>): SpaceEntryPresenterModel {
    return {
      specificationVersion: this.version,
      id: model.id,
      name: model.value.space_information.name,
      description: model.value.space_information.description ?? null,
      dataEntity: model.dataEntity,
      icon: model.value.space_information.icon,
      entityVersion: model.entityVersion ?? 0,
      isEntryObsolete: model.invalidReason === 0,
      isEntryInvalid: model.invalidReason === 1,
      isImplicit: model.isImplicit,
      is_deactivated: model.value.is_deactivated,
      is_end_user_deactivated: model.value.is_end_user_deactivated,
      type: model.value.type,
      url: model.value.domain.url,
      domainIdentifier: model.value.domain.domain_identifier,
      fullUrl: `https://${model.value.domain.full_url}`,
    };
  }
  getDataModel(presenter: SpaceEntryPresenterModel): SpaceEntry {
    const model = {
      specificationVersion: this.version,
      dataEntity: SPACE_CORE_ENTITY_ID,
      value: {
        space_information: {
          name: presenter.name,
          description: presenter.description,
          icon: presenter.icon,
        },
        domain: {
          url: presenter.url,
          domain_identifier: presenter.domainIdentifier,
          full_url: presenter.fullUrl,
        },
        is_deactivated: presenter.is_deactivated,
        is_end_user_deactivated: presenter.is_end_user_deactivated,
        type: presenter.type,
      },
    } as SpaceEntry;

    return model;
  }
}
